module.exports = __webpack_public_path__ + "static/media/tracker_screenshot_en.53d671ab.png";